var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      class: { mobile: _vm.isMobile(_vm.$mq) },
      attrs: {
        id: "subpack-modal",
        "no-border-radius": false,
        small: true,
        "show-close-button": false,
        isReferralModal: false,
        "is-subpack-modal": true,
        paywall: true
      },
      on: { close: _vm.bubbleClose }
    },
    [
      _c("Blurb", {
        attrs: {
          title: "Thank you for your interest!",
          description:
            "The Math Only subscription plan is coming soon. We’ll email you when it’s available. In the meantime, check out our other plan options.",
          "button-text": "Got it!",
          "image-src": "/site_media/version-0/images/paywall/math-subpack.svg",
          "image-alt": "Math fundamentals",
          "large-theme": true,
          "referral-theme": false,
          "subpack-theme": true
        },
        on: { "button-clicked": _vm.closeSubpackModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }